import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["disabled", "aria-disabled"]
const _hoisted_2 = {
  key: 0,
  class: "dropdown-item-after"
}

import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItem',
  props: {
  disabled:             Boolean,
  /**
   * For a command that changes the checkbox or radio items beside it, eg Select All or Reset: the
   * menu stays open, as it does for those items, so their new state shows. The focus stays on the
   * command, so a screen reader hears nothing of that: say what changed in a live region
   */
  actsOnCheckableItems: Boolean,
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

/**
 * An item for a dropdown menu. Used in conjunction with RcDropdown.
 */
const props = __props;
const emits = __emit;

const {
  handleKeydown,
  close,
  handleActivate,
  scrollIntoView,
  handleMouseenter,
} = useDropdownItem();

const handleClick = (e: MouseEvent) => {
  if (props.disabled) {
    return;
  }

  emits('click', e);

  if (!props.actsOnCheckableItems) {
    close();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdownMenuItem",
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitem",
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onMousedown: _withModifiers(() => {/*We use this to prevent clicks from triggering the @focusin below. When we scroll on a click it prevents the action from occurring on the first click.*/}, ["prevent"]),
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args))),
    onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleMouseenter) && _unref(handleMouseenter)(...args)))
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "default"),
    _cache[5] || (_cache[5] = _createTextVNode()),
    (_ctx.$slots.after)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "after")
        ]))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})